import { Routes } from "@angular/router";
import { CalendarViewComponent } from "./list-components/calendar-view/calendar-view.component";
import { KanbanViewComponent } from "./list-components/kanban-view/kanban-view.component";
import { ListViewComponent } from "./list-components/list-view/list-view.component";
import { TaskViewComponentComponent } from "./task-view-component/task-view-component.component";

export const taskManagementRoutes: Routes = [
  {
    path: "",
    component: TaskViewComponentComponent,
  },
  {
    path: "list-view",
    component: ListViewComponent,
  },
  {
    path: "kanban",
    component: KanbanViewComponent,
  },
  {
    path: "calendar",
    component: CalendarViewComponent,
  },
  {
    path: "task-detail/:id",
    component: TaskViewComponentComponent,
  },
];
